import {
    ENTITLEMENT_DATA,
  } from '../../../../constants';
  
  
  export const initialState = {
    isEntitlementsLoading: false,
    selectededTab: 0,
    isMainScreen: false,
    isAddNew: false,
    loading: false,
    errors: {}, // You can store the form errors here
    isActiveLoading: false, // You can store the active loading here
    isDeactiveLoading: false, // You can store the deactive loading here
    isResultsFound: false, // variable for result found here
    isEntitlementsShippingInfoByIdResultsFound: false, // variable for result found here
    errorModal: null, // variable for error modal here
    noDataFound: false, // variable for no data found here
    alertDialog: false, // variable for alert dialog here
    alertText: ENTITLEMENT_DATA.errorMsg, // variable for alert text here
    apiSuccessResponse: {
      activate: false,
      deactivate: false,
      create: false,
      update: false,
    }, // You can store the api success response here
  
    //Entitlement Id Search and Data fetched by Id
    entitlementsQuickSearchId: '', // You can store Quick Search Id here
    tmpentitlementsQuickSearchId: '', // You can store Quick Search Id here
  
    //Entitlements Shipping Info Data
    entitlementsShippingInfoData: [], // You can store the entitlements Shipping Info data here
  
    //User Details
    user: '',
    userId: 0,
  };
  